module.exports = __webpack_public_path__ + "static/img/crb_cd_pic.c6f4390.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crb_cd_pic.png
// module id = 3VBE
// module chunks = 200